import script from "./AssetManagers.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetManagers.vue?vue&type=script&setup=true&lang=js"

import "./AssetManagers.vue?vue&type=style&index=0&id=163681dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163681dc"]])

export default __exports__